export function isSandbox(): boolean {
    return (import.meta as any).env.MODE === 'development';
}

export function isProduction(): boolean {
    return !isSandbox() && !process.env.IS_DEVELOPMENT && !process.env.REACT_APP_IS_DEVELOPMENT;
}
